<html>
<head>
<meta charset="utf-8">
</head>
<body style="padding: 30px;">

<div  dir="RTL">
<p align="center" dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.PAGE_TITLE' | translate }}</u></strong>
    <strong><u>SlickChain</u></strong>
</p>
<p align="center" dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_GENERAL' | translate }}</u></strong>
    <u></u>
</p>
<ol start="1" type="1" style="text-align:right">
    <li dir="RTL">
        {{ 'TERMS.PAGE.P1' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P2' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P3' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P4' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P5' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P6' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P7' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P8' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P9' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P10' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P11' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P12' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P13' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P14' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P15' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P16' | translate }}
    </li>
</ol>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_USE' | translate }}</u></strong>
</p>
<ol start="17" type="1">
    <li dir="RTL">
        הרישום הבסיסי לאתר הינו ללא עלות. לקוח אשר בחר להירשם לאתר יוכל להשתמש
        בשירותים הבאים:<strong><u></u></strong>
    </li>
</ol>
<p dir="RTL">
    א.
    <strong>
        <u>{{ 'TERMS.PAGE.SHIPPING_SERVICE_TITLE' | translate }}</u>
    </strong>
    – לקוח אשר בוחר בשירות זה יוכל להכניס לאתר באופן עצמאי את נתוני הרכב אותו
    הוא עתיד לייבא לישראל ואת נתוני המשלוח ולקבל הצעת מחיר ממפעילת האתר אודות
    עלות יבוא הרכב, עלות השילוח, עלות שחרור הרכב מהמכס, עלות המיסים וכו' (להלן:
    "<strong>שירות שילוח</strong>").<strong><u></u></strong>
</p>
<p dir="RTL">
    ב. <strong><u>{{ 'TERMS.PAGE.PURCHASE_SERVICE_TITLE' | translate }}</u></strong> – שירות אשר מאפשר
    ללקוח לבחור רכב אותו רוצה לייבא לישראל מרשימת הרכבים המוצעים באתר ולקבל
    הצעת מחיר הכוללת את מחיר הרכב, השילוח, שחרור ברכב מהמכס, מיסים וכו' (להלן:
    "<strong>שירות רכישת ויבוא רכב</strong>" וביחד עם שירות השילוח יקראו להלן:
    "<strong>שירותי החברה</strong>").<strong><u></u></strong>
</p>
<ol start="18" type="1">
    <li dir="RTL">
        הלקוח מצהיר בזאת כי הוא מודע לעובדה שכל תפקידה של מפעילת האתר בקשר עם
        שירותי החברה ו/או שירות השילוח הינו לשמש כגורם מתאם בלבד לצורך ענייני
        רכש הרכבים, הלוגיסטיקה וההובלה הימית ו/או היבשתית של כלי הרכב המיובאים.
    </li>
    <li dir="RTL">
        לפיכך מפעילת האתר אינה אחראית לשינויי נתיב ההובלה ו/או משך ההובלה ו/או
        איחורים בהגעה ו/או במסירת הרכב ו/או נזק ו/או חוסר שייגרמו בעת שהרכב
        אינו בחזקתה בפועל של החברה.
    </li>
    <li dir="RTL">
        הלקוח מצהיר בזאת כי הוא מודע לעובדה כי פרטי הטיסה ו/או הפלגה כמו גם
        לוחות הזמנים בקשר לשירותי החברה הינם משוערים בלבד, בהתאם לנתונים
        הנמסרים ע"י חברת התעופה ו/או הספנות וכפופים לשינויים המבוצעים על ידן.
        על כן, הלקוח מצהיר בזאת כי לא תהיה לו כל תלונה ו/או טענה כלפי החברה
        בעיכובים כאלה ואחרים אשר אינן השליטה של מפעילת האתר בקשר עם יבוא הרכבים
        ושילוחם ללקוח.
    </li>
    <li dir="RTL">
        מובהר בזאת, כי כלל האחריות הן לגבי ייצור הרכב, פגמים ברכב, עיכובים
        בייצור, עיכובים בשילוח וכל היוצא בזאת הינה באחריות יצרן הרכב, ספק הרכב,
        חברות ההובלה היבשתית, המחסנים, נמלי הים, וחברות הספנות איתן עובדת
        מפעילת האתר.
    </li>
    <li dir="RTL">
        מובהר בזאת כי מפעילת האתר עושה כל שביכולתה לתת ללקוח הצעת מחיר אשר תהיה
        מדויקת וקרובה ככל שניתן לעלות הסופית של הלקוח בקשר עם שירותי הרכש,
        היבוא ו/או השילוח. עם זאת, ראוי לציין כי חישוב עלות המיסים ועלויות
        הובלת הרכב הינן <strong><u>משוערות בלבד</u></strong> שכן ישנם גורמים
        אשר מפעילת האתר אינה יכולה לצפות מראש כגון: מיסים ואגרות ממדינת היצוא,
        בדיקות מכס בנמל הטעינה, השטעון ו/או הפריקה, שינוי של שערי החליפין
        במטבעות זרים מזמן הזמנת הרכב ועד מעמד שחרור הרכב, שינויים של מחירי
        השינוע על ידי חברות התעופה והספנות, עלויות בלתי צפויות בנמלי הים,
        עלויות אחסנה, השהייה, פסילת ערך עסקה והוצאת גרעון בגין הפרש מיסים
        לתשלום על ידי מכס ישראל, בזמן הליך שחרור ובדיעבד, תשלום של קנסות וכופר
        המושתים ע"י המכס ו/או משרד התחבורה, וכו'.
    </li>
    <li dir="RTL">
        <strong>
            <u>
                הלקוח מצהיר בזאת כי הוא מודע לכך שהעלות הסופית עבור השירות
                הנבחר תקבע במעמד שחרור הרכב מהמכס בישראל בלבד
            </u>
        </strong>
        (למעט פסילת ערך בדיעבד, גם במקרה של פסילת "מסמך העדפה", והוצאת גרעון
        בגין הפרש מיסים לתשלום על ידי מכס ישראל ו/או תשלום של קנסות ו/או כופר
        המושתים על ידי המכס ו/או משרד התחבורה), כמו כן מובהר בזאת כי שיערוך
        העלויות אינו כולל הוצאות כגון: הובלה יבשתית בישראל, בדיקות מכס, הנפקת
        רישיונות ואישורים, אחסון ו/או השהיות, סבלות, מנוף, המתנה, התקנות, שמאות
        רכב, תקינה, וכל הוצאה אחרת כל שהיא לאחר שחרור הרכב מרשות המכס.
    </li>
    <li dir="RTL">
        מובהר בזאת כי התשלום בעבור שירותי החברה יעשה בהעברה בנקאית ו/או צ'ק
        במעמד שחרור הרכב מהמכס, אלא אם סוכם אחרת ובכתב בין משתמש האתר למפעילת
        האתר.
    </li>
    <li dir="RTL">
        <strong>
            <u>
                מובהר בזאת כי במידה ולא יוסדר התשלום על ידי הלקוח בעבור שירותי
                החברה אותם הוא רכש, מפעילת האתר שומרת לעצמה את הזכות לעכב כל
                סוג של משלוח ו/או רכב של משתמש האתר וזאת לצורך הבטחת הסדרת
                התשלום בעבור השירותים שסופקו על ידה, לרבות תשלומים בגין עסקאות
                ו/או משלוחים קודמים.
            </u>
        </strong>
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong>
        <u>{{ 'TERMS.PAGE.ORDER_EXECUTION_TITLE' | translate }}</u>
    </strong>
</p>
<ol start="26" type="1">
    <li dir="RTL">
        בעת הזמנת שירותי שילוח ו/או שירותי רכישת ויבוא רכב לישראל יתבקש המשתמש
        להקליד פרטים בסיסיים כמו שם, כתובת, כתובת דואר אלקטרוני ומספר טלפון. על
        מנת שההזמנה תבוצע במהירות וללא תקלות יש להקפיד על מסירת הפרטים הנכונים
        אחרת מפעילת האתר לא תוכל להבטיח את ביצוע ההזמנה.
    </li>
    <li dir="RTL">
        כמו כן, כפי שהובהר לעיל התשלום בעד שירותי החברה מתבסס על הערכת העלויות
        כפי שעולה מהזנת הנתונים במערכת, העלות הסופית תינתן אך ורק לאחר שחרור
        הרכב מרשות נמל אשדוד ותלויה בהזנת נתונים נכונים למערכת, שער החליפין,
        מיסוי משתנה, אגרות ועלויות נוספות שלא היו ידועות במעמד ההזמנה.
    </li>
    <li dir="RTL">
        מובהר בזאת כי במידה והאזור הנבחר ממנו הלקוח מעוניין לבצע שילוח לרכב
        המיובא, הינו אזור אשר לא מופיע ברשימת האזורים המוצעים על ידי מפעילת
        האתר, העלות שתקבע בגין שירות זה תהיה כמוסכם בין מפעילת האתר לבין הלקוח
        ותקבע לפני תיאום שירות שילוח הרכב.
    </li>
    <li dir="RTL">
        יודגש, כי מסירת פרטים כוזבים ביודעין עלולה לעלות כדי עבירה פלילית. נגד
        מגישי פרטים כוזבים עלולים להינקט צעדים משפטיים אזרחיים ופליליים, לרבות
        תביעות נזיקין בגין נזקים שיגרמו למפעילת האתר עקב שיבוש הפעלת האתר. כמו
        כן, המידע שיימסר על ידי המשתמש באתר ישמש בין השאר לשליחת דואר אלקטרוני
        בנוגע לעדכונים באתר.
    </li>
    <li dir="RTL">
        ההזמנה תרשם במחשבי מפעילת האתר ויישלח אישור בדואר אלקטרוני על ביצוע
        הפעולה מייד בסמוך לסיום ביצוע עסקת הרכישה על ידי המשתמש באתר. במקרה של
        אי קבלת הודעת האישור במייל יש לפנות לשירות הלקוחות.
    </li>
    <li dir="RTL">
        יובהר ויודגש, משלוח הודעת דואר אלקטרוני בדבר רישום ההזמנה במערכת
        הממוחשבת של מפעילת האתר אינה מהווה ראיה בדבר השלמת הפעולה ואין במשלוח
        הודעת הדוא"ל כדי לחייב את מפעילת האתר.
        <a name="_Hlk112316367">
            מובהר כי רישומי מערכת המחשב של מפעילת האתר הכוללים רישום ממוחשב
            ואוטומטי של כל הפעולות באתר מהווים ראיה לכאורה.
        </a>
    </li>
    <li dir="RTL">
        פרטי ההזמנה כפי שהזין המשתמש בטופס ההזמנה ורישום העסקה במחשבי האתר יהוו
        ראייה חלוטה וסופית לנכונות העסקה.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_PRODUCT_DELIVERY' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<ol start="33" type="1">
    <li dir="RTL">
        על מנת להבטיח את ביצוע ההזמנה ביעילות וללא תקלות, יש להקפיד על מסירת כל
        הפרטים הנדרשים באתר באופן מדויק ועדכני. אם בעת ביצוע ההזמנה יימסרו
        פרטים שגויים, מפעילת האתר לא תוכל להבטיח שההזמנה תיקלט.
    </li>
    <li dir="RTL">
        מפעילת האתר אינו אחראית לטיב השירות שניתן על ידי יצרני הרכב ו/או ספקי
        הרכב ו/או חברות ההובלה הימית/יבשתית, ו/או המחסנים ו/או נמלי הים איתם
        היא עובדת ואינה מבטיחה שלא יהיו עיכובים כאלו ואחרים בשילוח הרכב לבית
        הלקוח ו/או באספקת הרכב המבוקש על ידי יצרן הרכב.
    </li>
    <li dir="RTL">
        על הלקוח מוטלת האחריות לבדוק את אישור ההזמנה שנשלח בדואר האלקטרוני שמסר
        בכדי לוודא שאין טעות בהזמנה. לא תתקבל כל טענה כי הוזמן משהו שונה מתוכן
        אישור ההזמנה.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_VEHICLE_INSURANCE' | translate }}</u></strong>
</p>
<ol start="36" type="1">
    <li dir="RTL">
        <strong>
            <u>
                ראוי לציין כי הרכבים אשר נרכשים באתר ו/או נשלחים על ידי מפעילת
                האתר ללקוח אינם מבוטחים. מפעילת האתר ממליצה למשתמש האתר לבטח את
                הרכב אותו הוא מייבא ו/או משלח.
            </u>
        </strong>
    </li>
    <li dir="RTL">
        כמו כן, מפעילת האתר מאפשרת רכישת ביטוח רכב באתר כדלקמן:
    </li>
</ol>
<p dir="RTL">
    א. <strong><u>{{ 'TERMS.PAGE.INSURANCE_ALL_RISKS' | translate }}</u></strong> {{ 'TERMS.PAGE.INSURANCE_FOR_NEW' | translate }}
</p>
<p dir="RTL">
    ב. <strong><u>{{ 'TERMS.PAGE.INSURANCE_USED_CARGO' | translate }}</u></strong> {{ 'TERMS.PAGE.INSURANCE_UP_TO_YEAR' | translate }}
</p>
<p dir="RTL">
    ג. <strong><u>{{ 'TERMS.PAGE.INSURANCE_OLDER_COLLECTIBLE' | translate }}</u></strong> {{ 'TERMS.PAGE.INSURANCE_COVERED_BY' | translate }}
</p>
<ol start="38" type="1">
    <li dir="RTL">
        מובהר בזאת כי הכיסוי הביטוחי אשר ניתן לרכוש מעת מפעילת האתר הינו כולל
        מיסים ומחריג שריטות ו\או שפשופים ו\או מעיכות, נזקים מכאניים
        ואלקטרוניים, אלא אם הוכח בוודאות כי קרו במהלך ההובלה. בנוסף, הכיסוי
        הביטוחי יסתיים עם פריקת הרכב מהנמל ובמידה והרכב יובל על גבי מובילית עד
        לבית הלקוח, הכיסוי יסתיים בבית הלקוח.
    </li>
    <li dir="RTL">
        כמו כן, הביטוח הנרכש מעת מפעילת האתר אינו כולל כיסוי לצד ג', גוף או
        רכוש, אינו כולל כיסוי כאשר הרכב נוסע בכוחות עצמו להוציא פעולות השינוע
        ע"י עובדי הנמל.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_SITE_RESPONSIBILITY' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    40. אין לראות במידע המופיע באתר משום הבטחה כלשהי ו/או אחריות לטיב הרכבים
    ו/או לטיב שירות החברות שהן חלק משרשרת האספקה שאיתן עובדת מפעילת האתר.
</p>
<p dir="RTL">
    41. מפעילת האתר לא תהיה אחראית לשום נזק, ישיר או עקיף, אשר ייגרם למשתמש
    כתוצאה מהסתמכות על מידע המופיע באתר ו/או בקישורים לאתרים אחרים ו/או כל מקור
    מידע פנימי ו/או חיצוני אחר ו/או שימוש בשירותים אשר מוצגים על ידו.
</p>
<p dir="RTL">
    42. מפעילת האתר לא תהיה אחראית לכל נזק (ישיר או עקיף), הפסד, עגמת נפש
    והוצאות שייגרמו למשתמשים ו/או לצדדים שלישיים כלשהם בעקבות שימוש או הסתמכות
    על כל תוכן, מידע, נתון, מצג, תמונה, וידאו, אודיו, פרסומת, מוצר, שירות
    וכיוצא בזה המופעים באתר ובפרט לא תהיה אחראית לאמינות הפרטים אודות הרכבים
    אשר הועלו לאתר על ידי מפעילת האתר ולא לטיב התמונות אשר הועלו על ידי מפעילת
    האתר בקשר עם רכבים מסוימים.
</p>
<p dir="RTL">
    43. כל הסתמכות כאמור נעשית על-פי שיקול דעתו ואחריותו הבלעדית של המשתמש באתר
    ושל האנשים אשר השאירו פרטיהם בקשר עם שירותי החברה והרכבים אותם הם בחרו
    לייבא ולשלח לישראל.
</p>
<p dir="RTL">
    44. האתר ממליץ למשתמשים באתר לנהוג בזהירות, ולקרוא בעיון את המידע המוצג
    באתר ובכלל זה את המידע ביחס לשירות עצמו, תיאורו והתאמתו.
</p>
<p dir="RTL">
    45. האתר בכללותו, לרבות כל המידע המופיע בו, מוצע לציבור כמות שהוא, ויהיה
    מדויק ונכון ככל הניתן, ואולם, יתכן והמידע אינו שלם או לחלופין, יתכן ונפלו
    טעויות טכניות או אחרות במידע.
</p>
<p dir="RTL">
    46. השימוש באתר ייעשה על אחריותו הבלעדית והמלאה של כל משתמש. כל החלטה
    שתתקבל ביחס לתכנים שיתפרסמו באתר הינה באחריותו המלאה של המשתמש. האתר אינו
    מתחייב כי התכנים המתפרסמים באתר, יהיו מלאים, נכונים, חוקיים או מדויקים או
    יהלמו את ציפיותיו ודרישותיו של כל משתמש. האתר לא יישא באחריות כלשהי לכל
    תוצאה שתנבע מהם, או משימוש בהם, או מהסתמכות עליהם.
</p>
<p dir="RTL">
    47.
    <strong>
        <u>
            מובהר בזאת כי אחריותה של מפעילת האתר בהקשר שינוע הרכבים תהא מוגבלת
            על פי האמנות הבינלאומיות הרלבנטיות או על פי שטר המטען, אם הוצא ע"י
            מפעילת האתר, לרבות לעניין תקופות ההתיישנות וגובה האחריות
        </u>
    </strong>
    .
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_CANCELLATION_POLICY' | translate }}</u></strong>
</p>
<ol start="48" type="1">
    <li dir="RTL">
האמור בסעיף זה כפוף לחוק הגנת הצרכן התשמ״א-1981 (להלן: "        <strong>החוק</strong>").
    </li>
    <li dir="RTL">
        מובהר בזאת כי לגבי שירות רכישת הרכב והשילוח ניתן יהיה לבטל את הזמנת
        שירות כאמור אך ורק 14 ימים מיום הזמנת השירות וכל עוד לא נרכש הרכב
        והמשלח לא החל בפעולת השילוח, לרבות התחלת הליך מכס ו/או הנפקת מסמכי
        יצוא, לטובת הלקוח.
    </li>
    <li dir="RTL">
        מובהר בזאת כי לא תינתן אפשרות ביטול כאשר נרכש הרכב ו/או המשלח החל
        בפעולת השילוח ולא ינתן החזר כספי בגין זאת.
    </li>
    <li dir="RTL">
        במידה ומדובר בשירותים מתמשכים, קרי שירותים אשר ניתנים מחודש לחודש
        והתשלום עבורם מתחדש בהתאם, ניתן יהא לבטל את השירות בהתאם לחוק הגנת
        הצרכן, בהודעה כאמור לאמצעי הקשר המצ"ב מטה. הביטול ייכנס בהתאם לקבוע
        בחוק הגנת הצרכן (תוך 3 ימי עסקים).
        <br/>
        <br/>
    </li>
</ol>
<p dir="RTL">
    52. ככל ולקוח עומד בקריטריונים לעיל בנוגע לביטול איזה מהשירותים המוצעים על
    ידי החברה ויהיה מעוניין לבטל את ההזמנה, ביטול ההזמנה יהיה כרוך בעמלת דמי
    טיפול של 5% או 100 ₪, זיכוי כספי יינתן עפ״י האמור בחוק.
</p>
<ol start="53" type="1">
    <li dir="RTL">
        הודעה על ביטול עסקה תתבצע באמצעות דוא"ל – orders@slickchain.com.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_INTELLECTUAL_PROPERTY' | translate }}</u></strong>
</p>
<p dir="RTL">
    54. מלוא זכויות היוצרים, סימני המסחר והקניין הרוחני באתר, לרבות בתכני האתר,
    בעיצוב האתר, ובכל תוכנה, יישום, קוד מחשב, קובץ גרפי, תמונה, טקסט וכל חומר
    אחר הכלול באתר, הינם בבעלות מפעילת האתר בלבד. אין להעתיק, לצלם, להפיץ,
    להציג בפומבי או למסור לצד שלישי אחד מאלו.
</p>
<ol start="55" type="1">
    <li dir="RTL">
        אין לשכפל, להעתיק, לפרסם, לשווק, להפיץ ו/או לייצר עבודות נגזרות של כל
        חלק מן האתר.
    </li>
    <li dir="RTL">
        דומיין האתר, האתר, שם המותג, סימני המסחר (בין אם נרשמו ובין אם לאו),
        פיתוחי תוכנה שיפותחו על ידי מפעילת האתר וכיוצא בזה - הם כולם רכושה של
        מפעילת האתר בלבד. אין לעשות בהם שימוש בלא קבלת הסכמתה בכתב ומראש. כל
        מידע ו/או תצוגה המופיעים באתר, לרבות גרפיקה, עיצוב, הצגה מילולית, סימני
        מסחר, סימני לוגו כן עריכתם והצגתם של אלה, הנם בבעלות בלעדית של האתר
        ו/או מי מטעמו. אין להעתיק לשכפל, להפיץ, לפרסם או להשתמש בכל דרך אחרת את
        התכנים המופיעים באתר אלא אם מפעילת האתר נתנה את הסכמתה לכך, בכתב ומראש
        ואין בעצם הכניסה לאתר כדי להעניק רישיון ו/או זכות כלשהי כל המוצרים
        המוצגים באתר הינם חלק מקניינה הרוחני של בעלת המותג ו/או של צד ג' שהוא
        שאישר את השימוש בהם לה או למי מטעמה.
    </li>
</ol>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_ACTIVITY_CESSATION' | translate }}</u></strong>
</p>
<ol start="57" type="1">
    <li dir="RTL">
        האתר שומר לעצמו את הזכות להפסיק בכל עת, ועל פי שיקול דעתו הבלעדי את
        הפעילות באתר ו/או לביטול הזמנה של לקוח.
    </li>
</ol>
<p dir="RTL">
58. במידה ובוטלה הזמנה על פי החלטת האתר,    <strong><u>יזוכה הלקוח במלוא הסכום אותו שילם.</u></strong>
</p>
<ol start="59" type="1">
    <li dir="RTL">
        ככל והאתר יפסיק את פעילותו ו/או תבטל הזמנה מסויימת של לקוח, בגין טעות
        בתיאור המוצר, מחיר שגוי ו/או כל סיבה שהיא, לא תהיה ללקוח כל טענה ו/או
        תביעה כלפי האתר ו/או מי ממפעיליו. לחילופין ולפנים משורת הדין, רשאית
        מפעילת האתר לאשר את תנאי העסקה החדשה בהתאם לשיקול דעתה הבלעדי.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_MISCELLANEOUS' | translate }}</u></strong>
</p>
<ol start="60" type="1">
    <li dir="RTL">
        תנאי השימוש באתר מתקיימים באתר ובשירותים הכלולים בו באמצעות כל מחשב או
        מכשיר תקשורת אחר (כגון: טלפון סלולרי, טאבלט, מחשב יד וכו'). הם חלים על
        השימוש באתר גם ברשת האינטרנט וגם בכל רשת או אמצעי תקשורת אחר.
    </li>
    <li dir="RTL">
        האתר שומר לעצמו את הזכות לשנות את התקנון מפעם לפעם, להוסיף או לגרוע
        ממנו, ביחס לאתר כולו, לחלקו על פי שיקול דעתה הבלעדי וזאת ללא צורך במתן
        התראה ו/או הודעה מוקדמת. האחריות הבלעדית והמלאה להכרת התנאים להלן
        ולשימוש באתר על פי תנאים אלו חלה בכל עת על המשתמש בלבד.
    </li>
    <li dir="RTL">
        האתר עושה ככל שיכול לדאוג שהמידע שמופיע באתר יהיה המידע המדויק ביותר
        אבל יובהר כי עלולים להופיע בו, בתום לב אי דיוק מסוימים או טעויות והאתר
        לא יישא באחריות כל שהיא הנובעת מהן או קשורה אליהן, ט.ל.ח.
    </li>
    <li dir="RTL">
        כל התנהגות ו/או התנהלות של מפעילת האתר לטובת משתמש האתר מחוץ לגבולות
        שימוש האתר ובניגוד לאמור בתקנון, הינה לפנים משורת הדין בלבד ולא תשמש או
        תיחשב כויתור מצידה על האמור בתקנון זה.
    </li>
    <li dir="RTL">
        במידה ויחולו תקלות מחשוב אשר ימנעו באופן זמני שימוש באתר, תפעל מפעילת
        האתר לטיפול בהם בהקדם ולא יהיו למשתמשי האתר טענות או תביעות כנגדה בקשר
        לאירועים בתקופת התקלות והטיפול בהן.
    </li>
    <li dir="RTL">
        בכל מקרה של אי התאמה ו/או סתירה בין הקבוע בתקנון זה, לבין הנאמר בכל
        פרסום ו/או מידע אחר שפורסם ו/או ניתן על ידי מפעילת האתר ו/או מי מטעמה,
        בקשר עם תנאי השימוש ורכישת מוצרים באמצעות האתר, לרבות ברשתות החברתיות,
        תגברנה הוראות תקנון זה, לכל דבר ועניין.
    </li>
    <li dir="RTL">
        המחירים באתר אינם כוללים מע״מ על פי הדין ויובהר, כי המחיר הסופי הינו
        המחיר אשר יקבע במעמד שחרור הרכב מהמכס, בכפוף לנסיבות כפי שהובאו לעיל.
    </li>
    <li dir="RTL">
        הדין החל על הזמנתך ועל תקנון זה, הוא הדין בישראל בלבד. סמכות השיפוט
        הבלעדית לכל עניין ומחלוקת, נתונה לבית משפט בתל אביב.
    </li>
</ol>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_PRIVACY_POLICY' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong></strong>
</p>
<p dir="RTL">
    <strong>
        מפעילת האתר מכבדת את פרטיות המשתמשים באתר ורואה חשיבות רבה בשמירה עליה.
    </strong>
</p>
<p dir="RTL">
    <strong>
        מטרת מדיניות הפרטיות המובאת להלן הינה לפרט את יחס החברה המפעילה את האתר
        לכל נושא הפרטיות של המשתמשים באתר, לרבות המידע שמסרו המשתמשים באתר,
        המידע שנאסף על נוהגיהם באתר והשימוש שעושה האתר במידע זה.
    </strong>
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_COLLECTED_INFO' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<ol start="68" type="1">
    <li dir="RTL">
        הלקוח באתר יתבקש למסור את המידע האישי שלו על מנת לבצע הזמנה ורכישה
        באתר. מפעילת האתר נוקטת באמצעי הזהירות המקובלים על מנת לשמור ולהגן ככל
        הניתן על סודיות המידע האישי של לקוחותיה והיא תעשה בו שימוש לצרכים
        פנימיים בלבד, לרבות יצירת קשר עם המשתמשים, קבלת הצעות מחיר למשתמשים,
        פרסומות ומידע שיווקי של מפעילת האתר במידע והמשתמש אישר זאת באתר.
    </li>
    <li dir="RTL">
        המשתמש מצהיר כי בעת רישום לאתר ו/או העלאת מסמכים לאתר, המסמכים יועלו
        לענן ופרטיו ישמרו במאגר המידע של מפעילת האתר, מאגר רשום מספר 700070029.
    </li>
    <li dir="RTL">
        הינך מצהיר כי כל הפרטים האישיים, הנמסרים על ידך באתר, הינם נכונים
        ומלאים וכי הם נמסרים מרצונך החופשי ובהסכמתך המלאה, מבלי שחלה עליך חובה
        כלשהי למסרם. כאשר אתה מוסר באתר פרטים אישיים של צד שלישי, אתה מצהיר כי
        המידע נמסר בהסכמתו המפורשת של הצד השלישי.
    </li>
    <li dir="RTL">
        כאשר אתה משתמש באתר, יתכן שנאסף עליך מידע כגון:
    </li>
</ol>
<p dir="RTL">
    א. מידע על המחשב שלכם, כולל כתובת ה-IP שלכם, מיקומכם הגאוגרפי, סוג הדפדפן
    והגרסה שלו, ומערכת ההפעלה;
</p>
<p dir="RTL">
    ב. מידע על הביקורים והשימוש שלכם באתר, כולל מקור ההפניה, אורך הביקור, צפיות
    בעמודים, ונתיבי המעבר שלכם באתר;
</p>
<p dir="RTL">
    ג. מידע, כמו למשל כתובת הדואר האלקטרוני שלכם, שאתם מזינים בזמן ההרשמה לאתר
    שלנו;
</p>
<p dir="RTL">
    ד. מידע, כמו למשל השם וכתובת הדואר האלקטרוני שלכם, שאתם מזינים על מנת ליצור
    מנוי להודעות הדואר האלקטרוני שלנו
</p>
<p dir="RTL">
    ה. המידע שאתם מזינים בזמן השימוש בשירותים באתר שלנו;
</p>
<p dir="RTL">
    ו. מידע שנוצר בזמן השימוש באתר שלנו, כולל מתי, כמה, ובאילו נסיבות אתם
    משתמשים בו;
</p>
<p dir="RTL">
    ז. מידע שקשור לכל דבר שאתם רוכשים, שירותים בהם אתם משתמשים או העברות שאתם
    מבצעים באתר כולל את השם שלכם, הכתובת, מספר הטלפון, כתובת הדואר האלקטרוני
    ופרטי כרטיס האשראי שלכם.
</p>
<p dir="RTL">
    ח. בנוסף, אם התחברת באתר באמצעות מנגנון התחברות צד שלישי – כמו למשל –
    התחברות באמצעות חשבון ג'ימייל, טיקטוק, אינסטגרם פייסבוק ועוד, יתכן ויאספו
    עליך פרטים אישיים ומידע נוסף שיועברו מהצד השלישי לאתר.
</p>
<p dir="RTL">
    72. אם הינך מתחת לגיל 18, הינך מאשר כי קיבלת את הסכמת אחד ההורים או
    האפוטרופוס החוקי שלך בטרם השימוש באתר ומסירת הפרטים האישיים.
</p>
<p dir="RTL">
    73. כאשר אתה משתמש באתר, יתכן שנאסף עליך מידע כגון העמודים בהם צפית, מידע
    שקראת, מוצרים שרכשת, פרטי ההתחברות שלך – סוג המכשיר סוג הדפדפן כתובת ה IP,
    אמצעי התשלום ששימש אותך ועוד. אם התחברת באתר באמצעות מנגנון התחברות צד
    שלישי – כמו למשל – התחברות באמצעות חשבון ג'ימייל או פייסבוק, יתכן ויאספו
    עליך פרטים אישיים ומידע נוסף שיועברו מהצד השלישי לאתר. המידע שמסרת באתר
    והמידע שנאסף עליך בעת השימוש באתר כפופים למדיניות פרטיות זו ולהוראות כל דין
    לרבות החוק להגנת הפרטיות התשמ"א – 1981, תקנות הגנת הפרטיות (אבטחת מידע),
    התשע"ז – 2017 ותקנות ה- GDPR של האיחוד האירופאי.
</p>
<p dir="RTL">
    74. פרטיו האישים של המשתמש (דואר אלקטרוני ו/או מספר נייד בלבד), יישמרו על
    פי בקשת המשתמש באתר לטובת דיוור ישיר. להסרה יש לפנות בכתב לשירות הלקוחות
    במייל: orders@slickchain.com ו/או בטלפון: 0732-188188.
    <strong>
        <u>ביצוע ההסרה עתיד להימשך כ-14 ימי עבודה, מיום קבלת הפנייה</u>
    </strong>
    .
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_INFO_USAGE' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    75. מפעילת האתר תעשה שימוש בפרטי המשתמשים הרשומים באתר לצרכי תפעול האתר ועל
    מנת לאפשר את ביצוע הרכישה באתר, וכן, לצורך שמירת קשר עם המשתמש, על מנת
    לעדכן במבצעים, אירועים, הטבות, הודעות, סטטוס הזמנה, קולקציות חדשות וכו'
    בהתאם להעדפות הלקוח בעת שהותו באתר ובהתאם להעדפות מפעילת האתר בהודעות דוא"ל
    ומסרונים.
</p>
<p dir="RTL">
    76. המשתמש באתר מצהיר כי הוא מודע לכך שייתכן והאתר יאסוף נתונים סטטיסטיים
    על המשתמשים באתר (ללא זיהוי המשתמש), למשל – איזורי המגורים שבהם יש את
    הביקוש הגבוה ביותר לרכב מסוג מסוים וכד'. נתונים אלו עשויים לשמש את האתר
    וכן, האתר רשאי למכור אותם ליבואני רכב או גורמים אחרים אשר עשויים לעשות
    שימוש במידע סטטיסטי כאמור (במידע כאמור לא יועברו פרטים עבור משתמשים יחידים
    באופן פרטני).
</p>
<p dir="RTL">
    77. מפעילת האתר עשויה לעשות שימוש ב"עוגיות", המוכרות גם כ-"Cookies", על
    המחשבים של המשתמשים ועל מכשירי המובייל. מדובר בנוהל סטנדרטי הנהוג בקרב כל
    חנויות האינטרנט.
</p>
<p dir="RTL">
    78. מפעילת האתר מייחסת חשיבות עליונה לאבטחת המידע של לקוחותיה, כל מידע
    המתקבל באתר, בין אם נמסר על-ידי הלקוח ובין אם נאסף על-ידי Cookie בעת שימוש
    באתר, הוא לשימוש בלעדי של אתר לצורך תיעוד רכישות הלקוח וכן לטובת מבצעים
    עתידיים (כפוף למתן הסכמת הלקוח להיכלל ברשימת התפוצה של האתר).
</p>
<p dir="RTL">
    79. בכל מקרה,, מפעילת האתר תהא רשאית להעביר פרטיו האישיים של משתמש לצד
    שלישי במקרים בהם המשתמש ביצע מעשה או מחדל הפוגעים ו/או העלולים לפגוע
    במפעילת האתר ו/או בצדדים שלישיים כלשהם, המשתמש עשה שימוש בשירותי מפעילת
    האתר לביצוע מעשה בלתי חוקי, אם התקבל בידי מפעילת האתר צו שיפוטי המורה לה
    למסור את פרטי המשתמש לצד שלישי וכן בכל מחלוקת או הליך משפטי.
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_MAILING_AUTHORIZATION' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    80. גולש שהשאיר פרטים באתר ומצורף לרשימת הדיוור של האתר, מאשר שימוש בפרטיו
    לצורך קבלת מידע שיווקי, עדכונים ופרסומות שיבצע האתר מעת לעת.
</p>
<p dir="RTL">
    81. על גולש שהשאיר פרטים כאמור תחולנה הוראות הדיוור המפורטות בתקנון להלן.
</p>
<p dir="RTL">
    82. אין להשאיר פרטים של אדם אחר באתר שלא בהסכמתו ו/או ללא נוכחותו מול המסך
    בשעת השארת הפרטים ולאחר שהוסברו לו כל תנאי התקנון.
</p>
<p dir="RTL">
    83. בעת השארת הפרטים יתבקש הגולש למסור פרטים אישיים כגון: שם פרטי, שם
    משפחה, טלפון וכן כתובת דואר אלקטרוני פעילה (לשיקול דעתו הבלעדי של האתר).
    מסירת פרטים חלקיים או שגויים עלולים למנוע את האפשרות להשתמש בשירות ולסכל
    יצירת קשר במקרה הצורך. במקרה של שינוי פרטים יש לעדכנם באתר.
</p>
<p dir="RTL">
    84. מובהר כי אין חובה על-פי חוק למסור פרטים באתר, אולם בלא למוסרם לא ניתן
    יהיה לקבל תוכן שיווקי ועדכונים מהאתר.
</p>
<p dir="RTL">
    85. האתר לא יעשה בפרטים שנמסרו שימוש, אלא בהתאם למדיניות הפרטיות של האתר
    המהווה חלק בלתי נפרד מהתקנון.
</p>
<p dir="RTL">
    86. השארת פרטים באתר ואישור לקבלת תוכן שיווקי כוללת, בין היתר, קבלת תוכן
    שיווקי, מידע ביחס למבצעים, עדכונים והנחות המוצעים למשתמשים רשומים.
</p>
<p dir="RTL">
    87. אישור דיוור (קבלת תוכן שיווקי) כאמור, מהווה את הסכמתו של הגולש למשלוח
    דברי פרסומת על-פי חוק התקשורת (בזק ושידורים) (תיקון מס' 40) התשס"ח – 2008
    ("<strong>חוק התקשורת</strong>").
</p>
<p dir="RTL">
    88. מובהר כי באפשרות משאיר הפרטים להסיר עצמו בכל עת מהדיוור באמצעות לחיצה
    על "להסרה מרשימת התפוצה" או כל מלל דומה שמופיע בתחתית כל דיוור שנשלח או
    באמצעות פנייה לאתר בדוא"ל. כל עוד לא הסיר עצמו הנרשם מרשימת הדיוור כאמור,
    רשאי האתר, בכפוף לחוק התקשורת, להעביר לנרשם דיוור ישיר כאמור.
</p>
<p dir="RTL">
    89. האתר רשאי לבטל את רישומו של גולש לרשימת הדיוור לפי שיקול דעתו המוחלט.
    מבלי לגרוע מהאמור לעיל, רשאי האתר למנוע גלישת גולש ו/או לבטל רישום לרשימת
    הדיוור, או לחסום גישה אליו בכל אחד מהמקרים הבאים:
</p>
<p dir="RTL">
    א. אם בעת השארת הפרטים ו/או הרכישה באתר נמסרו במתכוון פרטים שגויים;
</p>
<p dir="RTL">
    ב. במקרה שנעשה שימוש באתר לביצוע או כדי לנסות לבצע מעשה בלתי חוקי על-פי
    דיני מדינת ישראל, או מעשה הנחזה על פניו כבלתי חוקי כאמור, או כדי לאפשר,
    להקל, לסייע או לעודד ביצועו של מעשה כזה;
</p>
<p dir="RTL">
    ג. אם הופרו תנאי התקנון;
</p>
<p dir="RTL">
    ד. אם נעשתה על ידי גולש כל פעולה שתמנע מאחרים להמשיך ולהשתמש באתר בכל דרך
    שהיא.
</p>
<p dir="RTL">
    ה. אם, ועל פי שיקול דעתה הבלעדי של המפעילה, נראה שיש בפעולות המשתמש כדי
    להיטיב ו/או לאסוף מידע ו/או להשתמש במערכת, עם ו/או באמצעות מתחרה עסקי של
    המפעילה, בין אם שימוש על ידי משתמש הקשור לחברת שילוח בינלאומי ו/או חברת
    עמילות מכס ו/או כל חברה שאינה משתמשת פוטנציאלית רצויה במערכת.
</p>
<p dir="RTL">
    90. אין לראות במידע בדיוור משום הבטחה לתוצאה כלשהי ו/או אחריות למוצר ו/או
    לשירות המוצע בו.
</p>
<p dir="RTL">
    91. האתר לא יהיה אחראי לכל נזק (ישיר או עקיף), הפסד, עגמת נפש והוצאות
    שייגרמו למשאיר פרטים ו/או לצדדים שלישיים כלשהם בעקבות שימוש או הסתמכות על
    כל תוכן, מידע, נתון, מצג, פרסומת, מוצר, שירות וכד' המופיעים בדיוור. כל
    הסתמכות כאמור נעשית על-פי שיקול דעתו ואחריותו הבלעדית של משאיר הפרטים.
</p>
<p dir="RTL">
    92. הדיוור בכללותו, לרבות כל המידע המופיע בו, מוצע כמות שהוא, ויהיה מדויק
    ונכון ככל הניתן, ואולם, יתכן והמידע אינו שלם או לחלופין, יתכן ונפלו טעויות
    טכניות או אחרות במידע.
</p>
<p dir="RTL">
    93. הגולש מאשר כי לא תהיה לו כל טענה בקשר למודעות פרסום ו/או פרסומות
    המוצגות באתר, לרבות בקשר למיקומן באתר. מובהר כי בכל הנוגע למודעות פרסום
    המוצגות בחסות צד שלישי, לאתר אין כל התערבות בבחירת הפרסומות המוצגות.
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_SECURITY_PROCEDURES' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    94. מפעילת האתר משתמשת בתקני האבטחה הגבוהים ביותר על מנת לשמור ככל האפשר על
    סודיות המידע ופרטיות לקוחותיה.
</p>
<p dir="RTL">
    95. האתר מאובטח באמצעות פרוטוקול SSL, כלומר כל התקשורת שבין הדפדפן (אצל
    הלקוח) לאתר (כלומר שרת האינטרנט המאחסן את העמודים) הינה מוצפנת כך שלא ניתן
    לפענח את המידע המועבר בין הדפדפן לאתר.
</p>
<p dir="RTL">
    96. במקרים שאינם בשליטה ו/או נובעים מכוח עליון, מפעילת האתר לא תישא באחריות
    לכל נזק מכל סוג שהוא, עקיף או ישיר שיגרם למשתמש ו/או למי מטעמו, אם מידע
    יאבד או יגיע לגורם עוין ו/או יעשה בו שימוש שלא בהרשאה.
</p>
<p dir="RTL">
    97. מפעילת האתר עושה מאמץ לספק למשתמש שירות תקין ובאיכות גבוהה. יחד עם זאת,
    מפעילת האתר אינה מתחייבת שהשירות באתר לא יופרע, יינתן כסדרו או בלא הפסקות,
    יתקיים בבטחה וללא טעויות, ויהיה חסין מפני גישה בלתי-מורשית למחשבי מפעילת
    האתר, נזקים, קלקולים, תקלות או כשלים - לרבות תקלות בחומרה, בתוכנה או בקווי
    התקשורת לאתר - אצל מפעילת האתר או אצל מי מספקיה.
</p>
<p dir="RTL" style="text-align:right">
    98. המידע עליך מאוחסן במאגרי מידע המנוהלים על ידי מפעילת האתר ו/או על ידי
    צד שלישי מטעמה בכפוף לתקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017. מידע
    רגיש, כגון סיסמאות, נשמר במאגרי המידע בצורה מוצפנת. מאגרי המידע עשויים
    להימצא מחוץ לגבולות מדינת ישראל. בעצם השימוש באתר, אתה מסכים להעברת המידע
    עליך ולשמירתו מחוץ לגבולות ישראל.
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_INFO_ACCESS_RIGHT' | translate }}</u></strong>
</p>
<p dir="RTL">
    99. לפי חוק הגנת הפרטיות, התשמ"א-1981, הינך רשאי לעיין במידע עליך המוחזק
    במאגרי המידע של האתר. באם תמצא כי המידע עליך אינו נכון, שלם, ברור או
    מעודכן, הינך רשאי לפנות לחברה בבקשה לתקן את המידע עליך או למוחקו. אם המידע
    שבמאגרי המידע של האתר משמש לצורך פניה אישית אליך, הינך זכאי לדרוש שמידע זה
    יימחק.
</p>
<p dir="RTL">
    100. כל פנייה שלך לחברה בנוגע לעיון במידע עליך ו/או שינויו, תעשה בכתב לפי
    הפרטים המופיעים בעמוד יצירת הקשר באתר. מחובתך לוודא כי פנייתך הגיעה לחברה
    ומטופלת על ידה. מפעילת האתר מסירה מעצמה אחריות לפניות שלא הגיעו אליה ו/או
    שהגיעו אליה שלא בכתב ו/או שאינן קריאות וברורות.
</p>
<p dir="RTL">
    101. אם לדעתך האתר פוגע בפרטיות המשתמשים בו ככלל, או בפרטיותך כפרט, אנא פנה
    לחברה בכתב לפי הפרטים המופיעים בעמוד יצירת הקשר באתר.
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_PRIVACY_POLICY_CHANGE' | translate }}</u></strong>
</p>
<p dir="RTL">
    102. מפעילת האתר שומרת לעצמה את הזכות לעדכן מעת לעת וללא כל הודעה מוקדמת את
    מדיניות הפרטיות. השינויים במדיניות הפרטיות ייכנסו לתוקף בתוך 48 שעות מרגע
    העדכון. מפעילת האתר רשאית על פי שיקול דעתה לעדכן את המשתמשים בשינוי
    במדיניות הפרטיות. אם יבוצעו במדיניות שינויים מהותיים, תפורסם על-כך הודעה
    בעמוד הבית של האתר 30 ימים לפני כניסת השינויים לתוקף. המשך שימושך באתר
    מהווה הסכמה לנוסח המעודכן של מדיניות הפרטיות. אם אינך מסכים עם הנוסח
    המעודכן, עליך להפסיק את השימוש באתר.
</p>
</div>


<div  dir="RTL">
<p align="center" dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.PAGE_TITLE' | translate }}</u></strong>
    <strong><u>SlickChain</u></strong>
</p>
<p align="center" dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_GENERAL' | translate }}</u></strong>
    <u></u>
</p>
<ol start="1" type="1" style="text-align:right">
    <li dir="RTL">
        {{ 'TERMS.PAGE.P1' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P2' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P3' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P4' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P5' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P6' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P7' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P8' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P9' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P10' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P11' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P12' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P13' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P14' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P15' | translate }}
    </li>
    <li dir="RTL">
        {{ 'TERMS.PAGE.P16' | translate }}
    </li>
</ol>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_USE' | translate }}</u></strong>
</p>
<ol start="17" type="1">
    <li dir="RTL">
        הרישום הבסיסי לאתר הינו ללא עלות. לקוח אשר בחר להירשם לאתר יוכל להשתמש
        בשירותים הבאים:<strong><u></u></strong>
    </li>
</ol>
<p dir="RTL">
    א.
    <strong>
        <u>{{ 'TERMS.PAGE.SHIPPING_SERVICE_TITLE' | translate }}</u>
    </strong>
    – לקוח אשר בוחר בשירות זה יוכל להכניס לאתר באופן עצמאי את נתוני הרכב אותו
    הוא עתיד לייבא לישראל ואת נתוני המשלוח ולקבל הצעת מחיר ממפעילת האתר אודות
    עלות יבוא הרכב, עלות השילוח, עלות שחרור הרכב מהמכס, עלות המיסים וכו' (להלן:
    "<strong>שירות שילוח</strong>").<strong><u></u></strong>
</p>
<p dir="RTL">
    ב. <strong><u>{{ 'TERMS.PAGE.PURCHASE_SERVICE_TITLE' | translate }}</u></strong> – שירות אשר מאפשר
    ללקוח לבחור רכב אותו רוצה לייבא לישראל מרשימת הרכבים המוצעים באתר ולקבל
    הצעת מחיר הכוללת את מחיר הרכב, השילוח, שחרור ברכב מהמכס, מיסים וכו' (להלן:
    "<strong>שירות רכישת ויבוא רכב</strong>" וביחד עם שירות השילוח יקראו להלן:
    "<strong>שירותי החברה</strong>").<strong><u></u></strong>
</p>
<ol start="18" type="1">
    <li dir="RTL">
        הלקוח מצהיר בזאת כי הוא מודע לעובדה שכל תפקידה של מפעילת האתר בקשר עם
        שירותי החברה ו/או שירות השילוח הינו לשמש כגורם מתאם בלבד לצורך ענייני
        רכש הרכבים, הלוגיסטיקה וההובלה הימית ו/או היבשתית של כלי הרכב המיובאים.
    </li>
    <li dir="RTL">
        לפיכך מפעילת האתר אינה אחראית לשינויי נתיב ההובלה ו/או משך ההובלה ו/או
        איחורים בהגעה ו/או במסירת הרכב ו/או נזק ו/או חוסר שייגרמו בעת שהרכב
        אינו בחזקתה בפועל של החברה.
    </li>
    <li dir="RTL">
        הלקוח מצהיר בזאת כי הוא מודע לעובדה כי פרטי הטיסה ו/או הפלגה כמו גם
        לוחות הזמנים בקשר לשירותי החברה הינם משוערים בלבד, בהתאם לנתונים
        הנמסרים ע"י חברת התעופה ו/או הספנות וכפופים לשינויים המבוצעים על ידן.
        על כן, הלקוח מצהיר בזאת כי לא תהיה לו כל תלונה ו/או טענה כלפי החברה
        בעיכובים כאלה ואחרים אשר אינן השליטה של מפעילת האתר בקשר עם יבוא הרכבים
        ושילוחם ללקוח.
    </li>
    <li dir="RTL">
        מובהר בזאת, כי כלל האחריות הן לגבי ייצור הרכב, פגמים ברכב, עיכובים
        בייצור, עיכובים בשילוח וכל היוצא בזאת הינה באחריות יצרן הרכב, ספק הרכב,
        חברות ההובלה היבשתית, המחסנים, נמלי הים, וחברות הספנות איתן עובדת
        מפעילת האתר.
    </li>
    <li dir="RTL">
        מובהר בזאת כי מפעילת האתר עושה כל שביכולתה לתת ללקוח הצעת מחיר אשר תהיה
        מדויקת וקרובה ככל שניתן לעלות הסופית של הלקוח בקשר עם שירותי הרכש,
        היבוא ו/או השילוח. עם זאת, ראוי לציין כי חישוב עלות המיסים ועלויות
        הובלת הרכב הינן <strong><u>משוערות בלבד</u></strong> שכן ישנם גורמים
        אשר מפעילת האתר אינה יכולה לצפות מראש כגון: מיסים ואגרות ממדינת היצוא,
        בדיקות מכס בנמל הטעינה, השטעון ו/או הפריקה, שינוי של שערי החליפין
        במטבעות זרים מזמן הזמנת הרכב ועד מעמד שחרור הרכב, שינויים של מחירי
        השינוע על ידי חברות התעופה והספנות, עלויות בלתי צפויות בנמלי הים,
        עלויות אחסנה, השהייה, פסילת ערך עסקה והוצאת גרעון בגין הפרש מיסים
        לתשלום על ידי מכס ישראל, בזמן הליך שחרור ובדיעבד, תשלום של קנסות וכופר
        המושתים ע"י המכס ו/או משרד התחבורה, וכו'.
    </li>
    <li dir="RTL">
        <strong>
            <u>
                הלקוח מצהיר בזאת כי הוא מודע לכך שהעלות הסופית עבור השירות
                הנבחר תקבע במעמד שחרור הרכב מהמכס בישראל בלבד
            </u>
        </strong>
        (למעט פסילת ערך בדיעבד, גם במקרה של פסילת "מסמך העדפה", והוצאת גרעון
        בגין הפרש מיסים לתשלום על ידי מכס ישראל ו/או תשלום של קנסות ו/או כופר
        המושתים על ידי המכס ו/או משרד התחבורה), כמו כן מובהר בזאת כי שיערוך
        העלויות אינו כולל הוצאות כגון: הובלה יבשתית בישראל, בדיקות מכס, הנפקת
        רישיונות ואישורים, אחסון ו/או השהיות, סבלות, מנוף, המתנה, התקנות, שמאות
        רכב, תקינה, וכל הוצאה אחרת כל שהיא לאחר שחרור הרכב מרשות המכס.
    </li>
    <li dir="RTL">
        מובהר בזאת כי התשלום בעבור שירותי החברה יעשה בהעברה בנקאית ו/או צ'ק
        במעמד שחרור הרכב מהמכס, אלא אם סוכם אחרת ובכתב בין משתמש האתר למפעילת
        האתר.
    </li>
    <li dir="RTL">
        <strong>
            <u>
                מובהר בזאת כי במידה ולא יוסדר התשלום על ידי הלקוח בעבור שירותי
                החברה אותם הוא רכש, מפעילת האתר שומרת לעצמה את הזכות לעכב כל
                סוג של משלוח ו/או רכב של משתמש האתר וזאת לצורך הבטחת הסדרת
                התשלום בעבור השירותים שסופקו על ידה, לרבות תשלומים בגין עסקאות
                ו/או משלוחים קודמים.
            </u>
        </strong>
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong>
        <u>{{ 'TERMS.PAGE.ORDER_EXECUTION_TITLE' | translate }}</u>
    </strong>
</p>
<ol start="26" type="1">
    <li dir="RTL">
        בעת הזמנת שירותי שילוח ו/או שירותי רכישת ויבוא רכב לישראל יתבקש המשתמש
        להקליד פרטים בסיסיים כמו שם, כתובת, כתובת דואר אלקטרוני ומספר טלפון. על
        מנת שההזמנה תבוצע במהירות וללא תקלות יש להקפיד על מסירת הפרטים הנכונים
        אחרת מפעילת האתר לא תוכל להבטיח את ביצוע ההזמנה.
    </li>
    <li dir="RTL">
        כמו כן, כפי שהובהר לעיל התשלום בעד שירותי החברה מתבסס על הערכת העלויות
        כפי שעולה מהזנת הנתונים במערכת, העלות הסופית תינתן אך ורק לאחר שחרור
        הרכב מרשות נמל אשדוד ותלויה בהזנת נתונים נכונים למערכת, שער החליפין,
        מיסוי משתנה, אגרות ועלויות נוספות שלא היו ידועות במעמד ההזמנה.
    </li>
    <li dir="RTL">
        מובהר בזאת כי במידה והאזור הנבחר ממנו הלקוח מעוניין לבצע שילוח לרכב
        המיובא, הינו אזור אשר לא מופיע ברשימת האזורים המוצעים על ידי מפעילת
        האתר, העלות שתקבע בגין שירות זה תהיה כמוסכם בין מפעילת האתר לבין הלקוח
        ותקבע לפני תיאום שירות שילוח הרכב.
    </li>
    <li dir="RTL">
        יודגש, כי מסירת פרטים כוזבים ביודעין עלולה לעלות כדי עבירה פלילית. נגד
        מגישי פרטים כוזבים עלולים להינקט צעדים משפטיים אזרחיים ופליליים, לרבות
        תביעות נזיקין בגין נזקים שיגרמו למפעילת האתר עקב שיבוש הפעלת האתר. כמו
        כן, המידע שיימסר על ידי המשתמש באתר ישמש בין השאר לשליחת דואר אלקטרוני
        בנוגע לעדכונים באתר.
    </li>
    <li dir="RTL">
        ההזמנה תרשם במחשבי מפעילת האתר ויישלח אישור בדואר אלקטרוני על ביצוע
        הפעולה מייד בסמוך לסיום ביצוע עסקת הרכישה על ידי המשתמש באתר. במקרה של
        אי קבלת הודעת האישור במייל יש לפנות לשירות הלקוחות.
    </li>
    <li dir="RTL">
        יובהר ויודגש, משלוח הודעת דואר אלקטרוני בדבר רישום ההזמנה במערכת
        הממוחשבת של מפעילת האתר אינה מהווה ראיה בדבר השלמת הפעולה ואין במשלוח
        הודעת הדוא"ל כדי לחייב את מפעילת האתר.
        <a name="_Hlk112316367">
            מובהר כי רישומי מערכת המחשב של מפעילת האתר הכוללים רישום ממוחשב
            ואוטומטי של כל הפעולות באתר מהווים ראיה לכאורה.
        </a>
    </li>
    <li dir="RTL">
        פרטי ההזמנה כפי שהזין המשתמש בטופס ההזמנה ורישום העסקה במחשבי האתר יהוו
        ראייה חלוטה וסופית לנכונות העסקה.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_PRODUCT_DELIVERY' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<ol start="33" type="1">
    <li dir="RTL">
        על מנת להבטיח את ביצוע ההזמנה ביעילות וללא תקלות, יש להקפיד על מסירת כל
        הפרטים הנדרשים באתר באופן מדויק ועדכני. אם בעת ביצוע ההזמנה יימסרו
        פרטים שגויים, מפעילת האתר לא תוכל להבטיח שההזמנה תיקלט.
    </li>
    <li dir="RTL">
        מפעילת האתר אינו אחראית לטיב השירות שניתן על ידי יצרני הרכב ו/או ספקי
        הרכב ו/או חברות ההובלה הימית/יבשתית, ו/או המחסנים ו/או נמלי הים איתם
        היא עובדת ואינה מבטיחה שלא יהיו עיכובים כאלו ואחרים בשילוח הרכב לבית
        הלקוח ו/או באספקת הרכב המבוקש על ידי יצרן הרכב.
    </li>
    <li dir="RTL">
        על הלקוח מוטלת האחריות לבדוק את אישור ההזמנה שנשלח בדואר האלקטרוני שמסר
        בכדי לוודא שאין טעות בהזמנה. לא תתקבל כל טענה כי הוזמן משהו שונה מתוכן
        אישור ההזמנה.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_VEHICLE_INSURANCE' | translate }}</u></strong>
</p>
<ol start="36" type="1">
    <li dir="RTL">
        <strong>
            <u>
                ראוי לציין כי הרכבים אשר נרכשים באתר ו/או נשלחים על ידי מפעילת
                האתר ללקוח אינם מבוטחים. מפעילת האתר ממליצה למשתמש האתר לבטח את
                הרכב אותו הוא מייבא ו/או משלח.
            </u>
        </strong>
    </li>
    <li dir="RTL">
        כמו כן, מפעילת האתר מאפשרת רכישת ביטוח רכב באתר כדלקמן:
    </li>
</ol>
<p dir="RTL">
    א. <strong><u>{{ 'TERMS.PAGE.INSURANCE_ALL_RISKS' | translate }}</u></strong> {{ 'TERMS.PAGE.INSURANCE_FOR_NEW' | translate }}
</p>
<p dir="RTL">
    ב. <strong><u>{{ 'TERMS.PAGE.INSURANCE_USED_CARGO' | translate }}</u></strong> {{ 'TERMS.PAGE.INSURANCE_UP_TO_YEAR' | translate }}
</p>
<p dir="RTL">
    ג. <strong><u>{{ 'TERMS.PAGE.INSURANCE_OLDER_COLLECTIBLE' | translate }}</u></strong> {{ 'TERMS.PAGE.INSURANCE_COVERED_BY' | translate }}
</p>
<ol start="38" type="1">
    <li dir="RTL">
        מובהר בזאת כי הכיסוי הביטוחי אשר ניתן לרכוש מעת מפעילת האתר הינו כולל
        מיסים ומחריג שריטות ו\או שפשופים ו\או מעיכות, נזקים מכאניים
        ואלקטרוניים, אלא אם הוכח בוודאות כי קרו במהלך ההובלה. בנוסף, הכיסוי
        הביטוחי יסתיים עם פריקת הרכב מהנמל ובמידה והרכב יובל על גבי מובילית עד
        לבית הלקוח, הכיסוי יסתיים בבית הלקוח.
    </li>
    <li dir="RTL">
        כמו כן, הביטוח הנרכש מעת מפעילת האתר אינו כולל כיסוי לצד ג', גוף או
        רכוש, אינו כולל כיסוי כאשר הרכב נוסע בכוחות עצמו להוציא פעולות השינוע
        ע"י עובדי הנמל.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_SITE_RESPONSIBILITY' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    40. אין לראות במידע המופיע באתר משום הבטחה כלשהי ו/או אחריות לטיב הרכבים
    ו/או לטיב שירות החברות שהן חלק משרשרת האספקה שאיתן עובדת מפעילת האתר.
</p>
<p dir="RTL">
    41. מפעילת האתר לא תהיה אחראית לשום נזק, ישיר או עקיף, אשר ייגרם למשתמש
    כתוצאה מהסתמכות על מידע המופיע באתר ו/או בקישורים לאתרים אחרים ו/או כל מקור
    מידע פנימי ו/או חיצוני אחר ו/או שימוש בשירותים אשר מוצגים על ידו.
</p>
<p dir="RTL">
    42. מפעילת האתר לא תהיה אחראית לכל נזק (ישיר או עקיף), הפסד, עגמת נפש
    והוצאות שייגרמו למשתמשים ו/או לצדדים שלישיים כלשהם בעקבות שימוש או הסתמכות
    על כל תוכן, מידע, נתון, מצג, תמונה, וידאו, אודיו, פרסומת, מוצר, שירות
    וכיוצא בזה המופעים באתר ובפרט לא תהיה אחראית לאמינות הפרטים אודות הרכבים
    אשר הועלו לאתר על ידי מפעילת האתר ולא לטיב התמונות אשר הועלו על ידי מפעילת
    האתר בקשר עם רכבים מסוימים.
</p>
<p dir="RTL">
    43. כל הסתמכות כאמור נעשית על-פי שיקול דעתו ואחריותו הבלעדית של המשתמש באתר
    ושל האנשים אשר השאירו פרטיהם בקשר עם שירותי החברה והרכבים אותם הם בחרו
    לייבא ולשלח לישראל.
</p>
<p dir="RTL">
    44. האתר ממליץ למשתמשים באתר לנהוג בזהירות, ולקרוא בעיון את המידע המוצג
    באתר ובכלל זה את המידע ביחס לשירות עצמו, תיאורו והתאמתו.
</p>
<p dir="RTL">
    45. האתר בכללותו, לרבות כל המידע המופיע בו, מוצע לציבור כמות שהוא, ויהיה
    מדויק ונכון ככל הניתן, ואולם, יתכן והמידע אינו שלם או לחלופין, יתכן ונפלו
    טעויות טכניות או אחרות במידע.
</p>
<p dir="RTL">
    46. השימוש באתר ייעשה על אחריותו הבלעדית והמלאה של כל משתמש. כל החלטה
    שתתקבל ביחס לתכנים שיתפרסמו באתר הינה באחריותו המלאה של המשתמש. האתר אינו
    מתחייב כי התכנים המתפרסמים באתר, יהיו מלאים, נכונים, חוקיים או מדויקים או
    יהלמו את ציפיותיו ודרישותיו של כל משתמש. האתר לא יישא באחריות כלשהי לכל
    תוצאה שתנבע מהם, או משימוש בהם, או מהסתמכות עליהם.
</p>
<p dir="RTL">
    47.
    <strong>
        <u>
            מובהר בזאת כי אחריותה של מפעילת האתר בהקשר שינוע הרכבים תהא מוגבלת
            על פי האמנות הבינלאומיות הרלבנטיות או על פי שטר המטען, אם הוצא ע"י
            מפעילת האתר, לרבות לעניין תקופות ההתיישנות וגובה האחריות
        </u>
    </strong>
    .
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_CANCELLATION_POLICY' | translate }}</u></strong>
</p>
<ol start="48" type="1">
    <li dir="RTL">
האמור בסעיף זה כפוף לחוק הגנת הצרכן התשמ״א-1981 (להלן: "        <strong>החוק</strong>").
    </li>
    <li dir="RTL">
        מובהר בזאת כי לגבי שירות רכישת הרכב והשילוח ניתן יהיה לבטל את הזמנת
        שירות כאמור אך ורק 14 ימים מיום הזמנת השירות וכל עוד לא נרכש הרכב
        והמשלח לא החל בפעולת השילוח, לרבות התחלת הליך מכס ו/או הנפקת מסמכי
        יצוא, לטובת הלקוח.
    </li>
    <li dir="RTL">
        מובהר בזאת כי לא תינתן אפשרות ביטול כאשר נרכש הרכב ו/או המשלח החל
        בפעולת השילוח ולא ינתן החזר כספי בגין זאת.
    </li>
    <li dir="RTL">
        במידה ומדובר בשירותים מתמשכים, קרי שירותים אשר ניתנים מחודש לחודש
        והתשלום עבורם מתחדש בהתאם, ניתן יהא לבטל את השירות בהתאם לחוק הגנת
        הצרכן, בהודעה כאמור לאמצעי הקשר המצ"ב מטה. הביטול ייכנס בהתאם לקבוע
        בחוק הגנת הצרכן (תוך 3 ימי עסקים).
        <br/>
        <br/>
    </li>
</ol>
<p dir="RTL">
    52. ככל ולקוח עומד בקריטריונים לעיל בנוגע לביטול איזה מהשירותים המוצעים על
    ידי החברה ויהיה מעוניין לבטל את ההזמנה, ביטול ההזמנה יהיה כרוך בעמלת דמי
    טיפול של 5% או 100 ₪, זיכוי כספי יינתן עפ״י האמור בחוק.
</p>
<ol start="53" type="1">
    <li dir="RTL">
        הודעה על ביטול עסקה תתבצע באמצעות דוא"ל – orders@slickchain.com.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_INTELLECTUAL_PROPERTY' | translate }}</u></strong>
</p>
<p dir="RTL">
    54. מלוא זכויות היוצרים, סימני המסחר והקניין הרוחני באתר, לרבות בתכני האתר,
    בעיצוב האתר, ובכל תוכנה, יישום, קוד מחשב, קובץ גרפי, תמונה, טקסט וכל חומר
    אחר הכלול באתר, הינם בבעלות מפעילת האתר בלבד. אין להעתיק, לצלם, להפיץ,
    להציג בפומבי או למסור לצד שלישי אחד מאלו.
</p>
<ol start="55" type="1">
    <li dir="RTL">
        אין לשכפל, להעתיק, לפרסם, לשווק, להפיץ ו/או לייצר עבודות נגזרות של כל
        חלק מן האתר.
    </li>
    <li dir="RTL">
        דומיין האתר, האתר, שם המותג, סימני המסחר (בין אם נרשמו ובין אם לאו),
        פיתוחי תוכנה שיפותחו על ידי מפעילת האתר וכיוצא בזה - הם כולם רכושה של
        מפעילת האתר בלבד. אין לעשות בהם שימוש בלא קבלת הסכמתה בכתב ומראש. כל
        מידע ו/או תצוגה המופיעים באתר, לרבות גרפיקה, עיצוב, הצגה מילולית, סימני
        מסחר, סימני לוגו כן עריכתם והצגתם של אלה, הנם בבעלות בלעדית של האתר
        ו/או מי מטעמו. אין להעתיק לשכפל, להפיץ, לפרסם או להשתמש בכל דרך אחרת את
        התכנים המופיעים באתר אלא אם מפעילת האתר נתנה את הסכמתה לכך, בכתב ומראש
        ואין בעצם הכניסה לאתר כדי להעניק רישיון ו/או זכות כלשהי כל המוצרים
        המוצגים באתר הינם חלק מקניינה הרוחני של בעלת המותג ו/או של צד ג' שהוא
        שאישר את השימוש בהם לה או למי מטעמה.
    </li>
</ol>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_ACTIVITY_CESSATION' | translate }}</u></strong>
</p>
<ol start="57" type="1">
    <li dir="RTL">
        האתר שומר לעצמו את הזכות להפסיק בכל עת, ועל פי שיקול דעתו הבלעדי את
        הפעילות באתר ו/או לביטול הזמנה של לקוח.
    </li>
</ol>
<p dir="RTL">
58. במידה ובוטלה הזמנה על פי החלטת האתר,    <strong><u>יזוכה הלקוח במלוא הסכום אותו שילם.</u></strong>
</p>
<ol start="59" type="1">
    <li dir="RTL">
        ככל והאתר יפסיק את פעילותו ו/או תבטל הזמנה מסויימת של לקוח, בגין טעות
        בתיאור המוצר, מחיר שגוי ו/או כל סיבה שהיא, לא תהיה ללקוח כל טענה ו/או
        תביעה כלפי האתר ו/או מי ממפעיליו. לחילופין ולפנים משורת הדין, רשאית
        מפעילת האתר לאשר את תנאי העסקה החדשה בהתאם לשיקול דעתה הבלעדי.
    </li>
</ol>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_MISCELLANEOUS' | translate }}</u></strong>
</p>
<ol start="60" type="1">
    <li dir="RTL">
        תנאי השימוש באתר מתקיימים באתר ובשירותים הכלולים בו באמצעות כל מחשב או
        מכשיר תקשורת אחר (כגון: טלפון סלולרי, טאבלט, מחשב יד וכו'). הם חלים על
        השימוש באתר גם ברשת האינטרנט וגם בכל רשת או אמצעי תקשורת אחר.
    </li>
    <li dir="RTL">
        האתר שומר לעצמו את הזכות לשנות את התקנון מפעם לפעם, להוסיף או לגרוע
        ממנו, ביחס לאתר כולו, לחלקו על פי שיקול דעתה הבלעדי וזאת ללא צורך במתן
        התראה ו/או הודעה מוקדמת. האחריות הבלעדית והמלאה להכרת התנאים להלן
        ולשימוש באתר על פי תנאים אלו חלה בכל עת על המשתמש בלבד.
    </li>
    <li dir="RTL">
        האתר עושה ככל שיכול לדאוג שהמידע שמופיע באתר יהיה המידע המדויק ביותר
        אבל יובהר כי עלולים להופיע בו, בתום לב אי דיוק מסוימים או טעויות והאתר
        לא יישא באחריות כל שהיא הנובעת מהן או קשורה אליהן, ט.ל.ח.
    </li>
    <li dir="RTL">
        כל התנהגות ו/או התנהלות של מפעילת האתר לטובת משתמש האתר מחוץ לגבולות
        שימוש האתר ובניגוד לאמור בתקנון, הינה לפנים משורת הדין בלבד ולא תשמש או
        תיחשב כויתור מצידה על האמור בתקנון זה.
    </li>
    <li dir="RTL">
        במידה ויחולו תקלות מחשוב אשר ימנעו באופן זמני שימוש באתר, תפעל מפעילת
        האתר לטיפול בהם בהקדם ולא יהיו למשתמשי האתר טענות או תביעות כנגדה בקשר
        לאירועים בתקופת התקלות והטיפול בהן.
    </li>
    <li dir="RTL">
        בכל מקרה של אי התאמה ו/או סתירה בין הקבוע בתקנון זה, לבין הנאמר בכל
        פרסום ו/או מידע אחר שפורסם ו/או ניתן על ידי מפעילת האתר ו/או מי מטעמה,
        בקשר עם תנאי השימוש ורכישת מוצרים באמצעות האתר, לרבות ברשתות החברתיות,
        תגברנה הוראות תקנון זה, לכל דבר ועניין.
    </li>
    <li dir="RTL">
        המחירים באתר אינם כוללים מע״מ על פי הדין ויובהר, כי המחיר הסופי הינו
        המחיר אשר יקבע במעמד שחרור הרכב מהמכס, בכפוף לנסיבות כפי שהובאו לעיל.
    </li>
    <li dir="RTL">
        הדין החל על הזמנתך ועל תקנון זה, הוא הדין בישראל בלבד. סמכות השיפוט
        הבלעדית לכל עניין ומחלוקת, נתונה לבית משפט בתל אביב.
    </li>
</ol>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_PRIVACY_POLICY' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong></strong>
</p>
<p dir="RTL">
    <strong>
        מפעילת האתר מכבדת את פרטיות המשתמשים באתר ורואה חשיבות רבה בשמירה עליה.
    </strong>
</p>
<p dir="RTL">
    <strong>
        מטרת מדיניות הפרטיות המובאת להלן הינה לפרט את יחס החברה המפעילה את האתר
        לכל נושא הפרטיות של המשתמשים באתר, לרבות המידע שמסרו המשתמשים באתר,
        המידע שנאסף על נוהגיהם באתר והשימוש שעושה האתר במידע זה.
    </strong>
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_COLLECTED_INFO' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<ol start="68" type="1">
    <li dir="RTL">
        הלקוח באתר יתבקש למסור את המידע האישי שלו על מנת לבצע הזמנה ורכישה
        באתר. מפעילת האתר נוקטת באמצעי הזהירות המקובלים על מנת לשמור ולהגן ככל
        הניתן על סודיות המידע האישי של לקוחותיה והיא תעשה בו שימוש לצרכים
        פנימיים בלבד, לרבות יצירת קשר עם המשתמשים, קבלת הצעות מחיר למשתמשים,
        פרסומות ומידע שיווקי של מפעילת האתר במידע והמשתמש אישר זאת באתר.
    </li>
    <li dir="RTL">
        המשתמש מצהיר כי בעת רישום לאתר ו/או העלאת מסמכים לאתר, המסמכים יועלו
        לענן ופרטיו ישמרו במאגר המידע של מפעילת האתר, מאגר רשום מספר 700070029.
    </li>
    <li dir="RTL">
        הינך מצהיר כי כל הפרטים האישיים, הנמסרים על ידך באתר, הינם נכונים
        ומלאים וכי הם נמסרים מרצונך החופשי ובהסכמתך המלאה, מבלי שחלה עליך חובה
        כלשהי למסרם. כאשר אתה מוסר באתר פרטים אישיים של צד שלישי, אתה מצהיר כי
        המידע נמסר בהסכמתו המפורשת של הצד השלישי.
    </li>
    <li dir="RTL">
        כאשר אתה משתמש באתר, יתכן שנאסף עליך מידע כגון:
    </li>
</ol>
<p dir="RTL">
    א. מידע על המחשב שלכם, כולל כתובת ה-IP שלכם, מיקומכם הגאוגרפי, סוג הדפדפן
    והגרסה שלו, ומערכת ההפעלה;
</p>
<p dir="RTL">
    ב. מידע על הביקורים והשימוש שלכם באתר, כולל מקור ההפניה, אורך הביקור, צפיות
    בעמודים, ונתיבי המעבר שלכם באתר;
</p>
<p dir="RTL">
    ג. מידע, כמו למשל כתובת הדואר האלקטרוני שלכם, שאתם מזינים בזמן ההרשמה לאתר
    שלנו;
</p>
<p dir="RTL">
    ד. מידע, כמו למשל השם וכתובת הדואר האלקטרוני שלכם, שאתם מזינים על מנת ליצור
    מנוי להודעות הדואר האלקטרוני שלנו
</p>
<p dir="RTL">
    ה. המידע שאתם מזינים בזמן השימוש בשירותים באתר שלנו;
</p>
<p dir="RTL">
    ו. מידע שנוצר בזמן השימוש באתר שלנו, כולל מתי, כמה, ובאילו נסיבות אתם
    משתמשים בו;
</p>
<p dir="RTL">
    ז. מידע שקשור לכל דבר שאתם רוכשים, שירותים בהם אתם משתמשים או העברות שאתם
    מבצעים באתר כולל את השם שלכם, הכתובת, מספר הטלפון, כתובת הדואר האלקטרוני
    ופרטי כרטיס האשראי שלכם.
</p>
<p dir="RTL">
    ח. בנוסף, אם התחברת באתר באמצעות מנגנון התחברות צד שלישי – כמו למשל –
    התחברות באמצעות חשבון ג'ימייל, טיקטוק, אינסטגרם פייסבוק ועוד, יתכן ויאספו
    עליך פרטים אישיים ומידע נוסף שיועברו מהצד השלישי לאתר.
</p>
<p dir="RTL">
    72. אם הינך מתחת לגיל 18, הינך מאשר כי קיבלת את הסכמת אחד ההורים או
    האפוטרופוס החוקי שלך בטרם השימוש באתר ומסירת הפרטים האישיים.
</p>
<p dir="RTL">
    73. כאשר אתה משתמש באתר, יתכן שנאסף עליך מידע כגון העמודים בהם צפית, מידע
    שקראת, מוצרים שרכשת, פרטי ההתחברות שלך – סוג המכשיר סוג הדפדפן כתובת ה IP,
    אמצעי התשלום ששימש אותך ועוד. אם התחברת באתר באמצעות מנגנון התחברות צד
    שלישי – כמו למשל – התחברות באמצעות חשבון ג'ימייל או פייסבוק, יתכן ויאספו
    עליך פרטים אישיים ומידע נוסף שיועברו מהצד השלישי לאתר. המידע שמסרת באתר
    והמידע שנאסף עליך בעת השימוש באתר כפופים למדיניות פרטיות זו ולהוראות כל דין
    לרבות החוק להגנת הפרטיות התשמ"א – 1981, תקנות הגנת הפרטיות (אבטחת מידע),
    התשע"ז – 2017 ותקנות ה- GDPR של האיחוד האירופאי.
</p>
<p dir="RTL">
    74. פרטיו האישים של המשתמש (דואר אלקטרוני ו/או מספר נייד בלבד), יישמרו על
    פי בקשת המשתמש באתר לטובת דיוור ישיר. להסרה יש לפנות בכתב לשירות הלקוחות
    במייל: orders@slickchain.com ו/או בטלפון: 0732-188188.
    <strong>
        <u>ביצוע ההסרה עתיד להימשך כ-14 ימי עבודה, מיום קבלת הפנייה</u>
    </strong>
    .
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_INFO_USAGE' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    75. מפעילת האתר תעשה שימוש בפרטי המשתמשים הרשומים באתר לצרכי תפעול האתר ועל
    מנת לאפשר את ביצוע הרכישה באתר, וכן, לצורך שמירת קשר עם המשתמש, על מנת
    לעדכן במבצעים, אירועים, הטבות, הודעות, סטטוס הזמנה, קולקציות חדשות וכו'
    בהתאם להעדפות הלקוח בעת שהותו באתר ובהתאם להעדפות מפעילת האתר בהודעות דוא"ל
    ומסרונים.
</p>
<p dir="RTL">
    76. המשתמש באתר מצהיר כי הוא מודע לכך שייתכן והאתר יאסוף נתונים סטטיסטיים
    על המשתמשים באתר (ללא זיהוי המשתמש), למשל – איזורי המגורים שבהם יש את
    הביקוש הגבוה ביותר לרכב מסוג מסוים וכד'. נתונים אלו עשויים לשמש את האתר
    וכן, האתר רשאי למכור אותם ליבואני רכב או גורמים אחרים אשר עשויים לעשות
    שימוש במידע סטטיסטי כאמור (במידע כאמור לא יועברו פרטים עבור משתמשים יחידים
    באופן פרטני).
</p>
<p dir="RTL">
    77. מפעילת האתר עשויה לעשות שימוש ב"עוגיות", המוכרות גם כ-"Cookies", על
    המחשבים של המשתמשים ועל מכשירי המובייל. מדובר בנוהל סטנדרטי הנהוג בקרב כל
    חנויות האינטרנט.
</p>
<p dir="RTL">
    78. מפעילת האתר מייחסת חשיבות עליונה לאבטחת המידע של לקוחותיה, כל מידע
    המתקבל באתר, בין אם נמסר על-ידי הלקוח ובין אם נאסף על-ידי Cookie בעת שימוש
    באתר, הוא לשימוש בלעדי של אתר לצורך תיעוד רכישות הלקוח וכן לטובת מבצעים
    עתידיים (כפוף למתן הסכמת הלקוח להיכלל ברשימת התפוצה של האתר).
</p>
<p dir="RTL">
    79. בכל מקרה,, מפעילת האתר תהא רשאית להעביר פרטיו האישיים של משתמש לצד
    שלישי במקרים בהם המשתמש ביצע מעשה או מחדל הפוגעים ו/או העלולים לפגוע
    במפעילת האתר ו/או בצדדים שלישיים כלשהם, המשתמש עשה שימוש בשירותי מפעילת
    האתר לביצוע מעשה בלתי חוקי, אם התקבל בידי מפעילת האתר צו שיפוטי המורה לה
    למסור את פרטי המשתמש לצד שלישי וכן בכל מחלוקת או הליך משפטי.
</p>
<p dir="RTL">
    <strong><u></u></strong>
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_MAILING_AUTHORIZATION' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    80. גולש שהשאיר פרטים באתר ומצורף לרשימת הדיוור של האתר, מאשר שימוש בפרטיו
    לצורך קבלת מידע שיווקי, עדכונים ופרסומות שיבצע האתר מעת לעת.
</p>
<p dir="RTL">
    81. על גולש שהשאיר פרטים כאמור תחולנה הוראות הדיוור המפורטות בתקנון להלן.
</p>
<p dir="RTL">
    82. אין להשאיר פרטים של אדם אחר באתר שלא בהסכמתו ו/או ללא נוכחותו מול המסך
    בשעת השארת הפרטים ולאחר שהוסברו לו כל תנאי התקנון.
</p>
<p dir="RTL">
    83. בעת השארת הפרטים יתבקש הגולש למסור פרטים אישיים כגון: שם פרטי, שם
    משפחה, טלפון וכן כתובת דואר אלקטרוני פעילה (לשיקול דעתו הבלעדי של האתר).
    מסירת פרטים חלקיים או שגויים עלולים למנוע את האפשרות להשתמש בשירות ולסכל
    יצירת קשר במקרה הצורך. במקרה של שינוי פרטים יש לעדכנם באתר.
</p>
<p dir="RTL">
    84. מובהר כי אין חובה על-פי חוק למסור פרטים באתר, אולם בלא למוסרם לא ניתן
    יהיה לקבל תוכן שיווקי ועדכונים מהאתר.
</p>
<p dir="RTL">
    85. האתר לא יעשה בפרטים שנמסרו שימוש, אלא בהתאם למדיניות הפרטיות של האתר
    המהווה חלק בלתי נפרד מהתקנון.
</p>
<p dir="RTL">
    86. השארת פרטים באתר ואישור לקבלת תוכן שיווקי כוללת, בין היתר, קבלת תוכן
    שיווקי, מידע ביחס למבצעים, עדכונים והנחות המוצעים למשתמשים רשומים.
</p>
<p dir="RTL">
    87. אישור דיוור (קבלת תוכן שיווקי) כאמור, מהווה את הסכמתו של הגולש למשלוח
    דברי פרסומת על-פי חוק התקשורת (בזק ושידורים) (תיקון מס' 40) התשס"ח – 2008
    ("<strong>חוק התקשורת</strong>").
</p>
<p dir="RTL">
    88. מובהר כי באפשרות משאיר הפרטים להסיר עצמו בכל עת מהדיוור באמצעות לחיצה
    על "להסרה מרשימת התפוצה" או כל מלל דומה שמופיע בתחתית כל דיוור שנשלח או
    באמצעות פנייה לאתר בדוא"ל. כל עוד לא הסיר עצמו הנרשם מרשימת הדיוור כאמור,
    רשאי האתר, בכפוף לחוק התקשורת, להעביר לנרשם דיוור ישיר כאמור.
</p>
<p dir="RTL">
    89. האתר רשאי לבטל את רישומו של גולש לרשימת הדיוור לפי שיקול דעתו המוחלט.
    מבלי לגרוע מהאמור לעיל, רשאי האתר למנוע גלישת גולש ו/או לבטל רישום לרשימת
    הדיוור, או לחסום גישה אליו בכל אחד מהמקרים הבאים:
</p>
<p dir="RTL">
    א. אם בעת השארת הפרטים ו/או הרכישה באתר נמסרו במתכוון פרטים שגויים;
</p>
<p dir="RTL">
    ב. במקרה שנעשה שימוש באתר לביצוע או כדי לנסות לבצע מעשה בלתי חוקי על-פי
    דיני מדינת ישראל, או מעשה הנחזה על פניו כבלתי חוקי כאמור, או כדי לאפשר,
    להקל, לסייע או לעודד ביצועו של מעשה כזה;
</p>
<p dir="RTL">
    ג. אם הופרו תנאי התקנון;
</p>
<p dir="RTL">
    ד. אם נעשתה על ידי גולש כל פעולה שתמנע מאחרים להמשיך ולהשתמש באתר בכל דרך
    שהיא.
</p>
<p dir="RTL">
    ה. אם, ועל פי שיקול דעתה הבלעדי של המפעילה, נראה שיש בפעולות המשתמש כדי
    להיטיב ו/או לאסוף מידע ו/או להשתמש במערכת, עם ו/או באמצעות מתחרה עסקי של
    המפעילה, בין אם שימוש על ידי משתמש הקשור לחברת שילוח בינלאומי ו/או חברת
    עמילות מכס ו/או כל חברה שאינה משתמשת פוטנציאלית רצויה במערכת.
</p>
<p dir="RTL">
    90. אין לראות במידע בדיוור משום הבטחה לתוצאה כלשהי ו/או אחריות למוצר ו/או
    לשירות המוצע בו.
</p>
<p dir="RTL">
    91. האתר לא יהיה אחראי לכל נזק (ישיר או עקיף), הפסד, עגמת נפש והוצאות
    שייגרמו למשאיר פרטים ו/או לצדדים שלישיים כלשהם בעקבות שימוש או הסתמכות על
    כל תוכן, מידע, נתון, מצג, פרסומת, מוצר, שירות וכד' המופיעים בדיוור. כל
    הסתמכות כאמור נעשית על-פי שיקול דעתו ואחריותו הבלעדית של משאיר הפרטים.
</p>
<p dir="RTL">
    92. הדיוור בכללותו, לרבות כל המידע המופיע בו, מוצע כמות שהוא, ויהיה מדויק
    ונכון ככל הניתן, ואולם, יתכן והמידע אינו שלם או לחלופין, יתכן ונפלו טעויות
    טכניות או אחרות במידע.
</p>
<p dir="RTL">
    93. הגולש מאשר כי לא תהיה לו כל טענה בקשר למודעות פרסום ו/או פרסומות
    המוצגות באתר, לרבות בקשר למיקומן באתר. מובהר כי בכל הנוגע למודעות פרסום
    המוצגות בחסות צד שלישי, לאתר אין כל התערבות בבחירת הפרסומות המוצגות.
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_SECURITY_PROCEDURES' | translate }}</u></strong>
    <strong><u></u></strong>
</p>
<p dir="RTL">
    94. מפעילת האתר משתמשת בתקני האבטחה הגבוהים ביותר על מנת לשמור ככל האפשר על
    סודיות המידע ופרטיות לקוחותיה.
</p>
<p dir="RTL">
    95. האתר מאובטח באמצעות פרוטוקול SSL, כלומר כל התקשורת שבין הדפדפן (אצל
    הלקוח) לאתר (כלומר שרת האינטרנט המאחסן את העמודים) הינה מוצפנת כך שלא ניתן
    לפענח את המידע המועבר בין הדפדפן לאתר.
</p>
<p dir="RTL">
    96. במקרים שאינם בשליטה ו/או נובעים מכוח עליון, מפעילת האתר לא תישא באחריות
    לכל נזק מכל סוג שהוא, עקיף או ישיר שיגרם למשתמש ו/או למי מטעמו, אם מידע
    יאבד או יגיע לגורם עוין ו/או יעשה בו שימוש שלא בהרשאה.
</p>
<p dir="RTL">
    97. מפעילת האתר עושה מאמץ לספק למשתמש שירות תקין ובאיכות גבוהה. יחד עם זאת,
    מפעילת האתר אינה מתחייבת שהשירות באתר לא יופרע, יינתן כסדרו או בלא הפסקות,
    יתקיים בבטחה וללא טעויות, ויהיה חסין מפני גישה בלתי-מורשית למחשבי מפעילת
    האתר, נזקים, קלקולים, תקלות או כשלים - לרבות תקלות בחומרה, בתוכנה או בקווי
    התקשורת לאתר - אצל מפעילת האתר או אצל מי מספקיה.
</p>
<p dir="RTL" style="text-align:right">
    98. המידע עליך מאוחסן במאגרי מידע המנוהלים על ידי מפעילת האתר ו/או על ידי
    צד שלישי מטעמה בכפוף לתקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017. מידע
    רגיש, כגון סיסמאות, נשמר במאגרי המידע בצורה מוצפנת. מאגרי המידע עשויים
    להימצא מחוץ לגבולות מדינת ישראל. בעצם השימוש באתר, אתה מסכים להעברת המידע
    עליך ולשמירתו מחוץ לגבולות ישראל.
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_INFO_ACCESS_RIGHT' | translate }}</u></strong>
</p>
<p dir="RTL">
    99. לפי חוק הגנת הפרטיות, התשמ"א-1981, הינך רשאי לעיין במידע עליך המוחזק
    במאגרי המידע של האתר. באם תמצא כי המידע עליך אינו נכון, שלם, ברור או
    מעודכן, הינך רשאי לפנות לחברה בבקשה לתקן את המידע עליך או למוחקו. אם המידע
    שבמאגרי המידע של האתר משמש לצורך פניה אישית אליך, הינך זכאי לדרוש שמידע זה
    יימחק.
</p>
<p dir="RTL">
    100. כל פנייה שלך לחברה בנוגע לעיון במידע עליך ו/או שינויו, תעשה בכתב לפי
    הפרטים המופיעים בעמוד יצירת הקשר באתר. מחובתך לוודא כי פנייתך הגיעה לחברה
    ומטופלת על ידה. מפעילת האתר מסירה מעצמה אחריות לפניות שלא הגיעו אליה ו/או
    שהגיעו אליה שלא בכתב ו/או שאינן קריאות וברורות.
</p>
<p dir="RTL">
    101. אם לדעתך האתר פוגע בפרטיות המשתמשים בו ככלל, או בפרטיותך כפרט, אנא פנה
    לחברה בכתב לפי הפרטים המופיעים בעמוד יצירת הקשר באתר.
</p>
<p dir="RTL">
    <strong><u>{{ 'TERMS.PAGE.SECTION_PRIVACY_POLICY_CHANGE' | translate }}</u></strong>
</p>
<p dir="RTL">
    102. מפעילת האתר שומרת לעצמה את הזכות לעדכן מעת לעת וללא כל הודעה מוקדמת את
    מדיניות הפרטיות. השינויים במדיניות הפרטיות ייכנסו לתוקף בתוך 48 שעות מרגע
    העדכון. מפעילת האתר רשאית על פי שיקול דעתה לעדכן את המשתמשים בשינוי
    במדיניות הפרטיות. אם יבוצעו במדיניות שינויים מהותיים, תפורסם על-כך הודעה
    בעמוד הבית של האתר 30 ימים לפני כניסת השינויים לתוקף. המשך שימושך באתר
    מהווה הסכמה לנוסח המעודכן של מדיניות הפרטיות. אם אינך מסכים עם הנוסח
    המעודכן, עליך להפסיק את השימוש באתר.
</p>
</div>
</body>
</html>
